
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/limit-orders",
      function () {
        return require("private-next-pages/limit-orders.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/limit-orders"])
      });
    }
  